;(({ $$, smoothScroll }) => {
    const allNews = $$('.one-news')
    allNews.forEach(news => {
        const triggers = news.querySelectorAll('.js-scrollTo-trigger')
        const targets = news.querySelectorAll('.js-scrollTo-target')

        triggers.forEach(trigger => {
            trigger.addEventListener('click', () => {
                const targetId = trigger.dataset.target
                const targetEl = Array.from(targets).filter(
                    target => target.dataset.anchor === targetId
                )
                smoothScroll(targetEl, 500)
            })
        })
    })
})(CNS)
